import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from 'react-icons/fi';

const Contact = () => {
  const navigate = useNavigate();
  
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const stagger = {
    visible: { transition: { staggerChildren: 0.1 } }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-900 to-green-900 text-white py-24">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Contáctanos
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-2xl">
              Estamos aquí para ayudarte. Ponte en contacto con nuestro equipo para cualquier consulta.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <motion.div
            className="grid md:grid-cols-2 gap-12"
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            {/* Contact Information */}
            <motion.div variants={fadeInUp}>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Información de contacto</h2>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-blue-100 p-3 rounded-full mr-4">
                    <FiMail className="text-blue-700 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">Correo electrónico</h3>
                    <p className="text-gray-600">info@experienciaspremium.com</p>
                    <p className="text-gray-600">soporte@experienciaspremium.com</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <FiPhone className="text-green-700 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">Teléfono</h3>
                    <p className="text-gray-600">+1 (123) 456-7890</p>
                    <p className="text-gray-600">Línea directa 24/7: +1 (123) 456-7891</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-amber-100 p-3 rounded-full mr-4">
                    <FiMapPin className="text-amber-700 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">Oficinas centrales</h3>
                    <p className="text-gray-600">123 Calle Premium</p>
                    <p className="text-gray-600">Ciudad Ejemplo, CP 12345</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-purple-100 p-3 rounded-full mr-4">
                    <FiClock className="text-purple-700 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">Horario de atención</h3>
                    <p className="text-gray-600">Lunes a Viernes: 9:00 - 18:00</p>
                    <p className="text-gray-600">Sábados: 10:00 - 14:00</p>
                  </div>
                </div>
              </div>
            </motion.div>
            
            {/* Contact Form */}
            <motion.div variants={fadeInUp}>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Envíanos un mensaje</h2>
              
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nombre completo</label>
                    <input
                      type="text"
                      id="name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      placeholder="Tu nombre"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Correo electrónico</label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      placeholder="tu@email.com"
                      required
                    />
                  </div>
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">Asunto</label>
                  <input
                    type="text"
                    id="subject"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    placeholder="¿Cómo podemos ayudarte?"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
                  <textarea
                    id="message"
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    placeholder="Escribe tu mensaje aquí..."
                    required
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white px-6 py-4 rounded-lg text-lg font-medium transition-all shadow-md hover:shadow-lg"
                >
                  <FiSend className="mr-2" />
                  Enviar mensaje
                </button>
              </form>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Map Section - Versión actualizada con Google Maps funcional */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-6">
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
            className="bg-white rounded-xl shadow-xl overflow-hidden"
          >
            <h2 className="text-2xl font-bold text-gray-900 p-6 pb-0">Nuestra ubicación</h2>
            <div className="h-96 w-full">
              {/* Mapa interactivo de Google Maps - ACTUALIZADO */}
              <iframe
                title="Ubicación de Experiencias Premium"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.215209132773!2d-73.98784492452543!3d40.74844047138911!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="p-6 text-center">
              <p className="text-gray-600 mb-2">123 Calle Premium, Ciudad Ejemplo, CP 12345</p>
              <button
                onClick={() => window.open("https://www.google.com/maps/place/Empire+State+Building/@40.7484405,-73.9878531,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259a9b3117469:0xd134e199a405a163!8m2!3d40.7484405!4d-73.9852782!16zL20vMDJfMjA2")}
                className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center"
              >
                <FiMapPin className="mr-1" />
                Abrir en Google Maps
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-green-900 text-white">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            variants={fadeInUp}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">¿Necesitas ayuda inmediata?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Nuestro equipo de soporte está disponible 24/7 para asistirte con cualquier urgencia.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={() => navigate('/faq')}
                className="bg-white text-blue-900 hover:bg-gray-100 px-8 py-3 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl"
              >
                Preguntas frecuentes
              </button>
              <a
                href="tel:+11234567890"
                className="flex items-center justify-center bg-transparent border-2 border-white hover:bg-white hover:bg-opacity-10 px-8 py-3 rounded-lg text-lg font-semibold transition-all"
              >
                <FiPhone className="mr-2" />
                Llamar ahora
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 pt-16 pb-8">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">Experiencias Premium</h3>
              <p className="mb-6">
                Selección exclusiva de tours y actividades para viajeros exigentes.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <span className="sr-only">Instagram</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">Explorar</h3>
              <ul className="space-y-3">
                <li><button onClick={() => navigate('/destinos')} className="hover:text-white transition-colors">Destinos exclusivos</button></li>
                <li><button onClick={() => navigate('/experiencias')} className="hover:text-white transition-colors">Experiencias premium</button></li>
                <li><button onClick={() => navigate('/proveedores')} className="hover:text-white transition-colors">Proveedores verificados</button></li>
                <li><button onClick={() => navigate('/blog')} className="hover:text-white transition-colors">Blog de viajes</button></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">Empresa</h3>
              <ul className="space-y-3">
                <li><button onClick={() => navigate('/nosotros')} className="hover:text-white transition-colors">Nuestra filosofía</button></li>
                <li><button onClick={() => navigate('/equipo')} className="hover:text-white transition-colors">El equipo</button></li>
                <li><button onClick={() => navigate('/prensa')} className="hover:text-white transition-colors">Prensa</button></li>
                <li><button onClick={() => navigate('/trabajos')} className="hover:text-white transition-colors">Trabaja con nosotros</button></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-6">Asistencia</h3>
              <ul className="space-y-3">
                <li><button onClick={() => navigate('/contacto')} className="hover:text-white transition-colors">Contacto</button></li>
                <li><button onClick={() => navigate('/faq')} className="hover:text-white transition-colors">Preguntas frecuentes</button></li>
                <li><button onClick={() => navigate('/privacidad')} className="hover:text-white transition-colors">Privacidad</button></li>
                <li><button onClick={() => navigate('/terminos')} className="hover:text-white transition-colors">Términos y condiciones</button></li>
              </ul>
            </div>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-center">
            <p>© {new Date().getFullYear()} Experiencias Premium. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;